
export const MAXIMUM_NODE_COUNT = 500;
